/**
 * Utility helper functions for resolving Entity Names (Brand, Model, Category, Region, Manufacturer)
 * across Autosphere/Spare Parts, Engineering, Rental, and Building/Others product lists.
 */

export const resolveEntityName = (
  value,
  masterList = [],
  fallbackLabel = "Unknown",
  extraProps = []
) => {
  if (value === null || value === undefined || value === "") {
    return fallbackLabel;
  }

  // 1. If value is an object
  if (typeof value === "object") {
    const nameKeys = [
      "name",
      "brandName",
      "categoryName",
      "modelName",
      "regionName",
      "manufacturerName",
      "subcategoryName",
      "title",
      "label",
      ...extraProps,
    ];
    for (const key of nameKeys) {
      if (value[key] && typeof value[key] === "string" && value[key].trim() !== "") {
        return value[key];
      }
    }
    // If object has _id but no text name property, use _id for array lookup below
    if (value._id) {
      value = value._id;
    } else {
      return fallbackLabel;
    }
  }

  // 2. If value is a string (ID or text name)
  if (typeof value === "string") {
    const trimmed = value.trim();
    if (!trimmed) return fallbackLabel;

    // Search masterList if provided
    if (Array.isArray(masterList) && masterList.length > 0) {
      const found = masterList.find(
        (item) =>
          item &&
          (item._id === trimmed ||
            item._id?.toString() === trimmed ||
            item.id === trimmed ||
            item.id?.toString() === trimmed)
      );
      if (found) {
        const foundName =
          found.name ||
          found.brandName ||
          found.categoryName ||
          found.modelName ||
          found.regionName ||
          found.manufacturerName ||
          found.subcategoryName ||
          found.title ||
          found.label;
        if (foundName) return foundName;
      }
    }

    // 3. If it's NOT a 24-character hex Mongo ObjectId, it's likely already the text name!
    const isMongoId = /^[0-9a-fA-F]{24}$/.test(trimmed);
    if (!isMongoId) {
      return trimmed;
    }
  }

  return fallbackLabel;
};

export const getProductName = (product) => {
  if (!product) return "N/A";
  return (
    product.name ||
    product.partName ||
    product.rentalItem ||
    product.meterialName ||
    product.productName ||
    product.title ||
    "N/A"
  );
};

export const getProductPartNo = (product) => {
  if (!product) return "N/A";
  return (
    product.partNo ||
    product.partNumber ||
    product.meterialcode ||
    product.itemCode ||
    product.code ||
    "N/A"
  );
};

export const getProductYear = (product) => {
  if (!product) return "N/A";
  return product.year || product.modelYear || product.years || "N/A";
};
